import { SiteReportUtilitySteps } from "../../../typings/SiteUtilityReport";
import { OverviewContentStep } from "./OverviewStepContent";
import { Stores, useGlobalState } from "../../../../../lib";
import { PaymentSuccessPage } from "./PaymentSuccessPage";
import { ErrorPage } from "./ErrorPage";

export const ReportSidebarContent: React.FC = () => {
  const [{ activeSiteReportUtilityStep }] = useGlobalState(Stores.site);

  switch (activeSiteReportUtilityStep) {
    case SiteReportUtilitySteps.Overview:
      return <OverviewContentStep />;
    case SiteReportUtilitySteps.Success:
      return <PaymentSuccessPage />;
    case SiteReportUtilitySteps.Error:
    default:
      return <ErrorPage />;
  }
};
